import styled from 'styled-components';

export const LoginAdminContainerStyled = styled.div``;
